module.exports = __webpack_public_path__ + "static/media/short_text.47d9b19f.svg";